import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { MatDialogRef, MatDialogModule } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { IconComponent } from '../icon/icon.component';
import { IconName } from '@app/utils/enums/icon-enum';

@Component({
  selector: 'app-base-modal',
  standalone: true,
  imports: [MatDialogModule, IconComponent, TranslateModule],
  templateUrl: './base-modal.component.html',
  styleUrl: './base-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BaseModalComponent<T = unknown> {
  public title = input('');
  protected readonly IconName = IconName;
  private readonly dialogRef = inject(MatDialogRef<BaseModalComponent<T>>);

  public close(): void {
    this.dialogRef.close();
  }
}
